export function matchesInputPattern(pattern: string, value: string) {
  try {
    return new RegExp(pattern, pattern.includes('\\p') ? 'u' : undefined).test(value)
  } catch {
    return false
  }
}
